import { Button, Row } from 'antd';
import { ICompanyInList } from 'app/containers/Company/slice/types';
import { FC } from 'react';
import { ColumnsType } from 'antd/lib/table';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectConfirmedCompanies } from 'app/containers/Company/slice/selectors';
import { TextRegular14 } from 'styles/typography';
import { StyledTable } from 'app/components/StyledTable/StyledTable';

interface IProps {
  search: string;
  onCompanyActivate: (clickedCompanyId: number) => void;
}

const CompaniesTable: FC<IProps> = ({ search, onCompanyActivate }) => {
  const { t } = useTranslation();
  const companies = useSelector(selectConfirmedCompanies);

  const filteredCompanies = companies?.filter(
    company => company.name.toLowerCase().indexOf(search.toLowerCase()) > -1,
  );

  const columns: ColumnsType<ICompanyInList> = [
    {
      title: t('Company.Companies', 'Companies'),
      dataIndex: 'name',
      render: (_: unknown, company) => company.name,
      sorter: {
        compare: (a: ICompanyInList, b: ICompanyInList) => {
          return a.name.localeCompare(b.name);
        },
      },
    },
    {
      title: t('Common.Actions', 'Actions'),
      dataIndex: 'actions',
      render: (_: unknown, company) => (
        <Button
          type="link"
          style={{ paddingLeft: 0 }}
          onClick={() => onCompanyActivate(company.id)}
        >
          {t('Company.Activate', 'Activate')}
        </Button>
      ),
    },
  ];

  return (
    <>
      <Row
        style={{
          margin: '19px 0 6px',
        }}
        justify="space-between"
      >
        <TextRegular14>
          {`${t('Common.Displayed', 'Displayed: ')} ${
            filteredCompanies?.length ?? ''
          }`}
        </TextRegular14>
        <Button type="link" onClick={() => onCompanyActivate(0)}>
          {t('Company.ActivateAll', 'Activate all')}
        </Button>
      </Row>
      <StyledTable
        dataSource={filteredCompanies}
        columns={columns}
        pagination={false}
        rowKey="id"
        style={{ paddingBottom: 50 }}
      />
    </>
  );
};

export default CompaniesTable;
